import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const lendersStart = () => {
  return {
    type: actionTypes.LENDERS_START
  };
};

export const lendersSuccess = payload => {
  return {
    type: actionTypes.LENDERS_SUCCESS,
    payload: payload
  };
};

export const lendersFail = error => {
  return {
    type: actionTypes.LENDERS_FAIL,
    error: error
  };
};
export const getLendersList = (getData, hideLoader) => {
  return dispatch => {
    if (!(hideLoader !== undefined && hideLoader === true)) {
      //dispatch(lendersStart());
    }
    axiosInstance()
      .get('/lenders.json', { params: getData })
      .then(response => {
        dispatch(lendersSuccess({ ...response.data, loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(lendersFail(err.response.data.message));
        } else {
          dispatch(lendersFail('Problem with connection to API.'));
        }
      });
  };
};

export const createLender = (postData, history) => {
  return dispatch => {
    dispatch(lendersStart());
    axiosInstance()
      .post('/lenders.json', postData)
      .then(response => {
        history.push('/lenders/' + response.data.id);
        dispatch(lendersSuccess({ loaded: false, list: [] }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(lendersFail(err.response.data.message));
        } else {
          dispatch(lendersFail('Problem with connection to API.'));
        }
      });
  };
};

export const editLender = (entityId, postData, callback) => {
  return dispatch => {
    dispatch(lendersStart());
    axiosInstance()
      .put(`/lenders/${entityId}.json`, postData)
      .then(response => {
        dispatch(lendersSuccess({ viewItem: response.data }));
        dispatch(lendersSuccess({ loaded: false, list: [] }));
        callback();
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(lendersFail(err.response.data.message));
        } else {
          dispatch(lendersFail('Problem with connection to API.'));
        }
      });
  };
};

export const getLender = entityId => {
  return dispatch => {
    axiosInstance()
      .get('/lenders/' + entityId + '.json')
      .then(response => {
        dispatch(lendersSuccess({ viewItem: response.data }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(lendersFail(err.response.data.message));
        } else {
          dispatch(lendersFail('Problem with connection to API.'));
        }
      });
  };
};
